export { default } from "./BlockFeaturedContent";
